import React from "react";
import { Route, Switch } from "react-router-dom";

import "./stylesheet/styles.css";
import "./stylesheet/App.css";
import "./stylesheet/cards.css";

import { Home } from "./components/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
import GamePlay from "./components/GamePlay";

import { GlobalProvider } from "./context/GlobalState";

function App() {
  return (
    <GlobalProvider>
      <Header />
      <Switch>
        <Route path="/" component={Home} exact />
        <Route path="/join/:gamecode" component={GamePlay} exact />
      </Switch>
      <Footer />
    </GlobalProvider>
  );
}

export default App;
